// src/utils/ensureMentoringSession.js
import axios from 'axios';

/**
 * Stellt sicher, dass der Mentoring-Dienst (hinter /mentoring) eine Session hat.
 * Ablauf:
 * 1) /mentoring/whoami prüfen -> wenn ok, fertig
 * 2) /auth/whoami lesen -> wenn eingeloggt, /mentoring/sso-attach aufrufen
 * 3) erneut /mentoring/whoami prüfen
 *
 * Gibt { ok:boolean, user?:object } zurück.
 */
export default async function ensureMentoringSession() {
  const BASE = window.location.origin.replace('http:', 'https:');

  // 1) Hat Mentoring schon eine Session?
  try {
    const r1 = await axios.get(`${BASE}/mentoring/whoami`, { withCredentials: true });
    if (r1?.data?.isAuthenticated) {
      return { ok: true, user: r1.data.user || null };
    }
  } catch (_) {}

  // 2) Hole AUTH-Kontext und hänge ihn an Mentoring an
  try {
    const a = await axios.get(`${BASE}/auth/whoami`, { withCredentials: true });
    if (a?.data?.isAuthenticated && a?.data?.user) {
      // ⚠️ Erwartet auf dem Mentoring-Server eine Route: POST /mentoring/sso-attach
      await axios.post(
        `${BASE}/mentoring/sso-attach`,
        { user: a.data.user },
        { withCredentials: true }
      );
    }
  } catch (_) {}

  // 3) Nochmals Mentoring prüfen
  try {
    const r2 = await axios.get(`${BASE}/mentoring/whoami`, { withCredentials: true });
    return { ok: !!r2?.data?.isAuthenticated, user: r2?.data?.user || null };
  } catch {
    return { ok: false, user: null };
  }
}
